import { render } from "./register.vue?vue&type=template&id=dbaf16c8&scoped=true"
const script = {}

import "./register.vue?vue&type=style&index=0&id=dbaf16c8&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/gurupadukaweb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbaf16c8"]])

export default __exports__